import { Component, OnInit , ViewChild} from '@angular/core';
import { GlobalService } from '../global-service.service';
import { MatNativeDateModule, MAT_DATE_LOCALE,DateAdapter  } from '@angular/material/core';
import { ActivatedRoute, Params} from '@angular/router';
//import { OptionenPipe } from '../optionen.pipe';
//import {MatButtonToggleModule} from '@angular/material/button-toggle';


@Component({
    selector: 'app-tarif',
    templateUrl: './tarif.component.html',
    styleUrls: ['../css/pasura.css'],
    standalone: false
})
export class TarifComponent implements OnInit {

  //@ViewChild('TGOptionen', {static: false}) private tgOpt: MatButtonToggleModule;
  
  
  tarife:any;
  selbstbehalt:[any];  
  tarif:any;
  subTarif:any;
  produkt:any;
  positionen:any;
  
  
  
  //optionenPipe:any;
  
  
  praemie = {
  		"TarifGen":"",
  		"TarifID":"",
  		"SubTarifID":"",
  		"GebDat":"",
  		"Sex":"F",
  		"VBeginn":"",  		
  		"VS":0,
  		"ProduktID":"",
  		"OptionBK":"Standard",
  		"Optionen":[] ,
  		"Selbstbehalt":0,
  		"FlottenRabattProz":0,
  		"FlottenRabattBehandlungskosten":false,
  		"clacOK":false
  }
  
  praemieOut:any;
  tarifInfos:any;
  TarifGen="2025";
  
  calcOn=true;
  
  constructor(public globserv: GlobalService, private dateAdapter: DateAdapter<Date>, private route:ActivatedRoute) 
  {
  		this.dateAdapter.setLocale('de');
  }

  ngOnInit() 
  {
		/*
  		this.route.params.subscribe((params: Params) => 
  		{
  			console.log("TarifGen=" + params['TarifGen'])
			if (params['TarifGen']!=undefined)
			{ 			
  				this.TarifGen = params['TarifGen'];
  				this.getTarife();
  			}
  		});
  		*/
  			this.globserv.getPasuraAction().subscribe((pasuraAction) => {
	      console.log("pasuraAction= " +pasuraAction)
	      if (typeof pasuraAction === 'string')
	      {
		      if (pasuraAction.startsWith("TarifGen"))
		      {
		      	var actionArray = pasuraAction.split(';');
		      	
		      	this.TarifGen = actionArray[1];
		      	this.getTarife();
		      }
		   }
    	});
    
  		
  		this.praemie.GebDat ="2026-01-01";
  	  
  }
  
  resetCalc()
  {
  		this.praemieOut=undefined;
  }
  
  onSubTarifChange(subTarifName)
  {
  		console.log("onSubTarifChange->" + subTarifName);
		for (let t of this.tarif.SubTarife)
  		{
  			console.log("t.Name->" + t.Name);
			if(t.Name==subTarifName)
			{
				console.log("found->" + t.Name);
				this.praemie.VS= 0;
				this.subTarif=t;
				break;
			}  		
  		}
  }
  
  
  getTarife()
  {
  		console.log("getTarife " +this.TarifGen);
  		var jsonResult;
  		
		this.globserv.getBackendData("/v1/getTarifStruktur?TarifGen="+ this.TarifGen, "").subscribe(
			result =>   jsonResult = result,
			
							err => {
		  					 				console.log("Error");
		  					 		 },
		  					 		 
		  					 	() => { 
		  					 		
		  					 		if (jsonResult.hasOwnProperty("Tarife"))
		  					 		{
			  					 		this.tarife=jsonResult.Tarife;
			  					 		console.log("Tarif=" +(this.tarife==undefined));
			  					 		
			  					 		if(this.tarife!=undefined)
			  					 		{
											 this.tarif=this.tarife[0];
											// this.optionenPipe = this.optPipe.transform(this.tarif.Optionen, this.praemie.ProduktID , this.praemie.Optionen);
											 this.subTarif=this.tarif.SubTarife[0];
											 this.produkt=this.tarif.Produkte[0];
											 this.selbstbehalt= this.subTarif.Selbstbehalt; 
											 	  					 		
											 this.praemie.TarifID=this.tarif.TarifID;
											 this.praemie.SubTarifID=this.subTarif.TarifID;
											 this.praemie.ProduktID=this.tarif.Produkte[0].ProduktID;
											 this.praemie.OptionBK="Standard";
											 this.praemie.Selbstbehalt=this.subTarif.Selbstbehalt[0].ID;
											 
											 console.log("SubTarifID=" +this.praemie.SubTarifID);
											 
											 this.praemie.VBeginn=this.tarif.nextVBeginn;
											 this.praemieOut=undefined;
			  					 		}
			  					 	}
							  	}		
							  		
		       			);
  }

  getPraemie()
  {
  		if (this.calcOn)
  		{
  			var backendResult;
  			this.positionen=[];
  		
	  		console.log("getPraemie");
	  		console.log("Selbstbehalt=" + this.praemie.Selbstbehalt);
	  		this.praemie.Selbstbehalt=Number(this.praemie.Selbstbehalt);
	  		console.log("VS=" + this.praemie.VS);
	  		console.log("Selbstbehalt=" + this.praemie.Selbstbehalt);
			
			if ( this.praemie.VS==undefined || isNaN(this.praemie.VS))
			{
				this.praemie.VS=0;
			}  		
			console.log("VS=" + this.praemie.VS);
			console.log("Calc=" + JSON.stringify(this.praemie));
			
			this.praemie.TarifGen=this.TarifGen;
			
	  		
			this.globserv.getBackendData("/v1/getPraemie", this.praemie).subscribe(
				result =>   backendResult = result,
								
								err => {
			  					 				console.log("Error");
			  					 		  },
			       			() => {
			       					
			       					if(backendResult.getPraemie!=undefined)
			       					{
			       							this.praemieOut=backendResult.getPraemie;
			       							
			       							
			       							if(this.praemieOut.VS!=undefined)
			       							{
			       							
			       								this.calcOn=false;
			       								this.praemie.VS= Number(this.praemieOut.VS);
			       								
			       								var keys = Object.keys(this.praemieOut);
			       								console.log("keys=" +keys);
			       								for(var i=0; i<keys.length; i++)
			       								{
													    var key =keys[i];
													    if (this.praemieOut[key].hasOwnProperty('Netto'))
													    {
													    	this.positionen.push(this.praemieOut[key]);
													    }
													}
			       								
			       								
			       								
			       								
			       								console.log("positionen=" +  JSON.stringify(this.positionen));
			       								this.calcOn=true;
			       							}
			       							console.log("result=" +  JSON.stringify(this.praemieOut));
			       							
			       					}
			       					this.tarifInfos=backendResult.Infos;
			       			}
			       			);
		}
  }

  toggleTarif(t)
  {
		
		this.tarif=t;		
		this.subTarif =t.SubTarife[0];		
		this.produkt=t.Produkte[0];
  		
  		this.praemie.TarifID=t.TarifID;
  		this.praemie.SubTarifID= this.subTarif.TarifID
  		this.praemie.ProduktID=this.tarif.Produkte[0].ProduktID;
  		
  		this.praemie.VS =0;
  		
  		
  		
  		//this.tarif=this.tarife[0];
		//this.subTarif=this.tarif.SubTarife[0];
		//this.produkt=this.tarif.Produkte[0];
											 	  					 		
		//this.praemie.TarifID=this.tarif.TarifID;
		//this.praemie.SubTarifID=this.subTarif.TarifID;
		//this.praemie.ProduktID=this.tarif.Produkte[0].ProduktID;
  		
  		this.getPraemie();
  }
  
  isSelTarif(t)
  {
		return t.TarifID==this.tarif.TarifID;
  }
  
  toggleSubTarif(subt)
  {
  		this.praemie.SubTarifID = subt.TarifID;
  		if (subt.hasOwnProperty('nextVBeginn'))
  		{
  			this.praemie.VBeginn=subt.nextVBeginn;
  		}else{
			this.praemie.VBeginn=this.tarif.nextVBeginn;  		
  		}
  		
		  		
  		
  		this.subTarif=subt;
  		this.getPraemie();
  		
  }
  
  isSelSubTarif(t)
  {
		return t.TarifID==this.subTarif.TarifID;
  }
  
  toggleProdukt(p)
  {
  		this.produkt=p;
  		this.praemie.ProduktID=p.ProduktID;
		if (p.ProduktID=='Behandlungskosten' || p.ProduktID=='Kombi')
		{
				
				if ((this.praemie.OptionBK=="Eco" && (!this.praemie.Optionen.includes("Helikoptertransport"))))
  				{
  					this.praemie.Optionen.push("Helikoptertransport"); //"Helikoptertransport"
  				}	 
  				
  				 
		}else if (p.ProduktID=='Todesfall' && this.praemie.Optionen.includes("Helikoptertransport")) 
		{
			
			this.praemie.Optionen.splice(this.praemie.Optionen.indexOf("Helikoptertransport"), 1);  	
		}
  		//this.optionenPipe = this.optPipe.transform(this.tarif.Optionen, this.praemie.ProduktID , this.praemie.Optionen);
  		this.getPraemie();
  }
   
  isSelProdukt(p)
  {
  		if (this.produkt==undefined)
  		{
			return false;  		
  		}
		return p.ProduktID==this.produkt.ProduktID;
  }
  
  toggleSB(sb)
  {
  		this.praemie.Selbstbehalt=sb.ID;
  		this.getPraemie();
  }
  
  isSelSB(sb)
  {
 		return this.praemie.Selbstbehalt==sb.ID;
  }

  toggleOptionBK(opt)
  {
  		console.log(opt.OptionID);
  		this.praemie.OptionBK=opt.OptionID;
  		
		if (opt.Selbstbehalt!=undefined)
		{
			this.selbstbehalt = opt.Selbstbehalt;
			
		} else {
			
			this.selbstbehalt= this.subTarif.Selbstbehalt; 
		}  		
  		
  		
  		this.getPraemie();
  }

  	 
  toggleOption(opt)
  {
  	
  	
  		let idx = this.praemie.Optionen.indexOf(opt.OptionID);
  		console.log("idx=" +idx);
  		
  		console.log("Optionen=" +this.praemie.Optionen);
  		console.log("OptionID=" +opt);
  		
  		if (idx>=0)
  		{
			this.praemie.Optionen.splice(idx, 1);  	
  		}else{
  			this.praemie.Optionen.push(opt.OptionID);  
		}
  		
  		console.log("Optionen=" +this.praemie.Optionen);
  		
  		
  		if (this.praemie.ProduktID=="Behandlungskosten" || this.praemie.ProduktID=="Kombi" )
  		{
  			
  			/*
  			if (!(this.praemie.Optionen.includes("Eco") || this.praemie.Optionen.includes("Standard")|| this.praemie.Optionen.includes("Premium")))
  			{
  				this.praemie.Optionen.push("Standard")
  				event.stopPropagation();
  			}
  			*/
  			
  			
  			if ((this.praemie.Optionen.includes("Eco") && (!this.praemie.Optionen.includes("Helikoptertransport"))))
  			{
  				this.praemie.Optionen.push("Helikoptertransport");
  			}  
  		}
  		
  		this.praemie.Optionen = JSON.parse(JSON.stringify(this.praemie.Optionen));
  		
  		
  		this.getPraemie();
  }
  
  isSelOption(opt)
  {
  		return this.praemie.Optionen.includes(opt);
  }


  isSelOptionBK(opt)
  {
  		return this.praemie.OptionBK==opt;
  }
  
  
  
  checkGebdat(event)
  {
		console.log(event);
		console.log(this.praemie.GebDat);  
  }
 
}
